import { Navigate } from 'react-router-dom';
import { useAuth } from '../../auth/hooks/useAuth';
import { LanguageToggle } from '../../locale/components/LanguageToggle';
import layoutStyles from '../../auth/components/AuthLayout.module.css';
import bootstrapStyles from '../../auth/components/BootstrapForm.module.css';
import primitives from '../../../styles/primitives.module.css';

export const BranchAccessWaitingPage = ({
  t,
  locale,
  onLocaleChange,
  onLogout,
  branchesInitialized,
}) => {
  const { requiresPasswordRenewal, isChecking } = useAuth();

  if (isChecking) {
    return null;
  }

  if (requiresPasswordRenewal) {
    return <Navigate to="/renew-password" replace />;
  }

  if (!branchesInitialized) {
    return <Navigate to="/branch-initialization" replace />;
  }

  return (
    <div className={layoutStyles.shell}>
      <main className={layoutStyles.panel}>
        <header className={layoutStyles.header}>
          <div className={layoutStyles.intro}>
            <p className={primitives.eyebrow}>{t('appName')}</p>
            <h1>{t('branchAccessWaitingTitle')}</h1>
            <p className={primitives.subtitle}>{t('branchAccessWaitingSubtitle')}</p>
          </div>
        </header>

        <section className={bootstrapStyles.container}>
          <div className={bootstrapStyles.header}>
            <h2>{t('branchAccessWaitingHeading')}</h2>
            <p>{t('branchAccessWaitingMessage')}</p>
          </div>
        </section>

        <div className={layoutStyles.actions}>
          <button className={primitives.ghostButton} type="button" onClick={onLogout}>
            {t('logout')}
          </button>
        </div>

        <div className={layoutStyles.footer}>
          <LanguageToggle locale={locale} onChange={onLocaleChange} />
        </div>
      </main>
    </div>
  );
};
